import { IonButton, IonButtons, IonIcon, IonModal, IonText, IonToolbar } from "@ionic/react";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import Image_3_nl from "@/assets/app/explainer/nl/3@2x.png";
import { xMarkIcon } from "@/lib/icons/@heroicons/react/20/solid";
import { useSelectorModalStore } from "@/lib/store/modal";

export function ModalCoreValuesExplainer() {
	const { t, i18n } = useTranslation();
	const modalRef = useRef<HTMLIonModalElement>(null);
	const modal = useSelectorModalStore.use.coreValuesExplainer();
	const present = useSelectorModalStore.use.present();
	const dismiss = useSelectorModalStore.use.dismiss();

	return (
		<IonModal
			ref={modalRef}
			isOpen={modal.isOpen}
			onWillPresent={() => {
				present("coreValuesExplainer");
			}}
			onWillDismiss={() => {
				dismiss("coreValuesExplainer");
			}}
			initialBreakpoint={1}
			breakpoints={[0, 1]}
			className="ion-min-h-[600px] ion-rounded-4xl ion-h-min"
		>
			<IonToolbar className="ion-bg-transparent pt-2">
				<IonButtons slot="end">
					<IonButton
						onClick={() => dismiss("coreValuesExplainer")}
						shape="round"
						className="part-icon:m-0 part-icon:size-5 part-native:size-10 part-native:min-h-0 part-native:rounded-full part-native:bg-brown-300 part-native:p-1 part-native:text-xs part-native:text-brown-600 min-h-0"
					>
						<IonIcon icon={xMarkIcon} />
					</IonButton>
				</IonButtons>
			</IonToolbar>

			<div className="flex flex-col gap-2 px-4">
				<div className="flex flex-col gap-2">
					<img
						src={
							{
								nl: Image_3_nl,
							}[i18n.language]
						}
						alt={t(`modal.app.explainer.steps.core-values.alt`)}
						className="max-h-[50dvh] w-full flex-1 object-contain"
					/>

					<div className="flex flex-col gap-3">
						<IonText className="text-brown-700 text-2xl font-semibold">
							{t(`modal.app.explainer.steps.core-values.title`)}
						</IonText>
						<IonText className="text-brown-600 pb-8">
							{t(`modal.app.explainer.steps.core-values.description`)}
						</IonText>
					</div>
				</div>
			</div>
		</IonModal>
	);
}
